<div class="dashboard row mb-3 g-3">
  <div class="col">
    <app-card-topups-balance-widget></app-card-topups-balance-widget>
  </div>
  <div class="col">
    <app-card-topups-balance-widget [isEmployeeCardBalance]="false"></app-card-topups-balance-widget>
  </div>
</div>
<div class="card shadow main-card">
  <div class="card-body">
    <app-table-header-template [searchOptions]="immediateTopUpSearchOptions">
      <ng-container filter>
        <app-recurring-topup-filter (query)="update($event)"></app-recurring-topup-filter>
      </ng-container>
      <ng-container buttons>
        <button
          (click)="onCreate()"
          id="createImmediateTopupButton"
          class="btn btn-primary btn-sm">
          Transfer
        </button>
      </ng-container>
    </app-table-header-template>

    <app-table
      [pageSize]="8"
      [columns]="columns"
      [getDataCallback]="getData"
      class="table-recurring-topups"
      emptyMessage="Your card top-ups will appear here.">
      <ng-template
        #cardDateCell
        let-value="value">
        {{ value | date: 'dd/MM/yyyy' }}<br />
        <span class="small text-black-50">{{ value | date: 'hh:mm a' }}</span>
      </ng-template>
      <ng-template
        #cardNumberCell
        let-value="value"
        let-row="row">
        <app-card-number-display
          [value]="value"
          [status]="row.card.status"></app-card-number-display>
      </ng-template>
      <ng-template
        #cardNameCell
        let-value="value">
        {{ value | emptyIndicator: 'Employee Card' }}
      </ng-template>
      <ng-template
        #cardHolderCell
        let-row="row"
        let-value="value">
        {{ value }} {{ row.card.holder.last_name }}
      </ng-template>
      <ng-template
        #transferredByCell
        let-row="row"
        let-value="value">
        {{ value }} {{ row.creator.last_name }}
      </ng-template>
      <ng-template
        class="text-end"
        #amountCell
        let-row="row"
        let-value="value">
        <div
          class="amount-style fw-semibold"
          [ngClass]="{ 'negative': row.type === CardFundType.Deduct }">
          {{ row.type === CardFundType.Deduct ? '- ' : '+ ' }}
          {{ absoluteValue(value) | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
        </div>
      </ng-template>
    </app-table>
  </div>
</div>

<div id="offCanvasGhostContainer">
  <router-outlet></router-outlet>
</div>
